import React, { Component } from 'react';
import __ from 'lodash';
import parse from 'html-react-parser';

class TblAsmCabangKompetensi extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            dataCabang: [],            
            arraykategori: [],
            arrayCabang: [],
            arrayProvinsi: [],
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.dataProvinsi)) {              
            this.setState({ dataCabang: this.props.data})
            let kategories = [], katProvinsi = [];           
            this.props.data.map(d => {
                d.kategories.map(k => {
                    kategories.push({ ...k, 'mapel': d.namaMataPelajaran})                    
                })
            }) 
            let filterKategories = kategories.filter( (ele, ind) => ind === kategories.findIndex( elem => elem.kategori === ele.kategori)); 

            this.props.dataProvinsi.map(prov => {
                prov.kategories.map(k => {
                    katProvinsi.push({ ...k, 'mapel': prov.namaMataPelajaran}) 
                })
            })

            this.setState({ arraykategori: filterKategories, arrayCabang: kategories, arrayProvinsi: katProvinsi})
        }

    }

    renderRow(kategori) {
        let result = "";
        this.state.dataCabang.map(d => {
            this.state.arrayCabang.map(cab =>{
                if(cab.kategori === kategori && cab.mapel === d.namaMataPelajaran) {
                    result += '<td style="text-align: center">'+cab.rataRata+'</td>';
                    result += '<td style="text-align: center">'+this.state.arrayProvinsi.find(p => p.kategori === kategori && p.mapel === d.namaMataPelajaran).rataRata+'</td>';
                    result += '<td style="text-align: center">'+cab.skorMax+'</td>';
                    result += '<td style="text-align: center">'+cab.skorMin+'</td>';
                }            
            })
        })
        return result;
    }

    render() {
        
        return(
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" rowSpan="2">LEVEL KOMPETENSI</th>
                        {this.state.dataCabang.map((d,i) => <th key={i} className="text-center" colSpan="4">{d.namaMataPelajaran}</th>)}
                    </tr>
                    <tr>
                        <th className="text-center">Rata-Rata</th>
                        <th className="text-center">Provinsi</th>
                        <th className="text-center">Tertinggi</th>
                        <th className="text-center">Terendah</th>

                        <th className="text-center">Rata-Rata</th>
                        <th className="text-center">Provinsi</th>
                        <th className="text-center">Tertinggi</th>
                        <th className="text-center">Terendah</th>
                    </tr>
                </thead>
                <tbody> 
                    {this.state.arraykategori.map((kateg,i) =>                                   
                    <tr key={i}>
                        <td>{kateg.kategori}</td>                        
                        {parse(this.renderRow(kateg.kategori))}                       
                    </tr>
                    )} 
                </tbody>
            </table>
        )
    }

}


export default TblAsmCabangKompetensi;

